import React, { useCallback, useState } from 'react'
import { useDebounceCallback } from 'usehooks-ts'

import { type GrapeAPIErrorType } from 'components/hooks/GrapeAPIError'
import { Button, Modal } from 'slab'
import { usePostMemberOnboardingInNetworkVerification } from 'utils/web_api'

import { useProviderInNetworkVerificationContext } from '../components/ProviderInNetworkVerificationContext/ProviderInNetworkVerificationContext'

export function useSubmitInNetworkVerificationRequest (onConfirmationSuccess?: () => void): {
  confirmationModal: React.ReactNode;
  isPending: boolean;
  error: GrapeAPIErrorType | null;
  submitInNetworkVerificationRequest: () => void;
} {
  const { selectedPlanIds, selectedProviderNpis, refetchInNetworkStatus, turnaroundDescription } = useProviderInNetworkVerificationContext()
  const { mutateAsync: postInNetworkVerification, isPending, error } = usePostMemberOnboardingInNetworkVerification<GrapeAPIErrorType>()
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const submitInNetworkVerificationRequest = useDebounceCallback(
    useCallback(async () => {
      window.segment?.track('InNetworkProviderVerification - submit', {
        planCount: selectedPlanIds.length,
        providerCount: selectedProviderNpis.length,
      })
      await postInNetworkVerification({
        data: {
          plan_ids: selectedPlanIds,
          provider_npis: selectedProviderNpis
        }
      })
      await refetchInNetworkStatus?.()
      setShowConfirmationModal(true)
      window.segment?.track('InNetworkProviderVerification - submit success')
    }, [selectedPlanIds, selectedProviderNpis])
    , 500)

  const closeModal = () => {
    setShowConfirmationModal(false)
    onConfirmationSuccess?.()
  }

  return {
    isPending,
    error,
    submitInNetworkVerificationRequest,
    confirmationModal: (
      <Modal
        open={showConfirmationModal}
        onOpenChange={closeModal}
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <Modal.Body>
          <Modal.Title>
            ✅  Got it!
          </Modal.Title>
          <Modal.Description>
            We'll call your providers and send you an email as soon as we have an update. {turnaroundDescription}
          </Modal.Description>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={closeModal}>Continue</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
